import React from "react";
import Text from "@/components/ui/text";
import IconContainer from "@/components/ui/icon-container";
import { Attachment, File } from "@dreamhub/designsystem/icons";
import DetailIconWrapper from "@/components/controls/Task/DetailIconWrapper";
import { SavedAttachmentInfo } from "@/entities/attachments/types";
import { map } from "lodash";

interface Props {
  attachments: { items: SavedAttachmentInfo[] };
  className?: string;
}

const AttachmentsIndicator: React.FC<Props> = ({ attachments, className }) => (
  <DetailIconWrapper
    tooltip={
      <div className="flex flex-col gap-2">
        {map(attachments?.items, (attachment) => (
          <div
            key={attachment.id}
            className="flex p-1 pl-[6px] gap-1 bg-surface-elevation1 rounded border-[0.5px] border-border-border2"
          >
            <IconContainer>
              <File />
            </IconContainer>
            <Text variant="smBody">{attachment.filename}</Text>
          </div>
        ))}
      </div>
    }
    className={className}
  >
    <IconContainer size="5" color="secondary">
      <Attachment />
    </IconContainer>
    {attachments?.items?.length > 1 && (
      <Text variant="smBodySecondary">{attachments?.items?.length}</Text>
    )}
  </DetailIconWrapper>
);

export default AttachmentsIndicator;
